import { gsap } from "gsap";

/* The following plugin is a Club GSAP perk */
import { Physics2DPlugin } from "gsap/Physics2DPlugin";


gsap.registerPlugin(Physics2DPlugin);
export default class MovingSectors{
    
    constructor(element) {
        this._wrapper = element;
        this._marqueeWrapper = this._wrapper.querySelector('.js-moving-sectors-marquee-wrapper');
        this._shapes = this._wrapper.querySelectorAll('.js-moving-sectors-shape');
        
        this.init();
        this.bindEvents();
    }
    
    init(){
        this.timelines = [];
        app.nodesEach(this._shapes, (el) => {
            let timeline = gsap.timeline({overwrite:true}) // 
                .to(el, {
                    x: this.getRandomX(el),
                    y: this.getRandomY(el),
                    duration: 6,
                    ease: "sine.inOut",
                    repeat:-1, repeatRefresh: true, // 
                })
                .to(el, {
                    rotation: "random(-180, 180, 10)",
                    duration: 6,
                    ease: "sine.inOut",
                    repeat:-1, repeatRefresh: true,
                }, 2)
            
            this.timelines.push(timeline);
        });
        
    }
    
    bindEvents(){
        window.addEventListener('resize', app.debounce(() => {
            this.timelines.forEach((item) => {
               item.kill(); 
            });
            this.init();
        }));
    }
    
    
    getRandomX(el){
        let offsetWidth = this._marqueeWrapper.offsetWidth;
        let elemWidth = el.offsetWidth;
        let total = offsetWidth - elemWidth;
        return 'random(0,'+total+',40)';
    }

    getRandomY(el){
        let offsetHeight = this._marqueeWrapper.offsetHeight;
        let elemHeight = el.offsetHeight;
        let total = offsetHeight - elemHeight;
        return 'random(0,'+total+',40)';
    }
    
}